import React from 'react';
import {
  IconShield,
  IconMail,
  IconDatabase,
  IconEye,
  IconTrash,
  IconFileText,
  IconServer,
  IconMapPin,
  IconActivity
} from '@tabler/icons-react';

const sections = [
  {
    icon: <IconShield className="w-5 h-5" />,
    title: 'Какие данные мы собираем',
    content: (
      <ul className="space-y-2">
        <li><strong>Имя пользователя и email</strong> — для регистрации и входа в сервис.</li>
        <li><strong>Хеш пароля</strong> — хранится в зашифрованном виде (bcrypt).</li>
        <li><strong>IP-адрес, порт, протокол</strong> — для работы туннелей.</li>
        <li><strong>Геолокационные данные</strong> — страна, город, регион, координаты (определяются по IP-адресу при подключении к туннелю).</li>
        <li><strong>Провайдер (ISP) и ASN</strong> — для аналитики и предотвращения злоупотреблений.</li>
        <li><strong>Данные о трафике</strong> — объём входящего и исходящего трафика (bytes_in, bytes_out).</li>
        <li><strong>Сессионные cookies</strong> — для аутентификации.</li>
      </ul>
    )
  },
  {
    icon: <IconServer className="w-5 h-5" />,
    title: 'Как мы используем данные',
    content: (
      <ul className="space-y-2">
        <li>Обеспечение работы туннелей (проброс портов).</li>
        <li>Мониторинг и аналитика использования сервиса.</li>
        <li>Предотвращение злоупотреблений и DDoS-атак.</li>
        <li>Техническая поддержка пользователей.</li>
      </ul>
    )
  },
  {
    icon: <IconDatabase className="w-5 h-5" />,
    title: 'Хранение данных',
    content: (
      <p>
        Все данные хранятся в PostgreSQL (Supabase) на территории Российской Федерации.
        Логи подключений хранятся до 90 дней, после чего удаляются.
      </p>
    )
  },
  {
    icon: <IconEye className="w-5 h-5" />,
    title: 'Передача данных третьим лицам',
    content: (
      <p>
        Мы не продаём и не передаём ваши персональные данные третьим лицам, кроме случаев,
        предусмотренных законодательством РФ. Данные геолокации определяются с помощью
        публичных GeoIP-баз данных и не передаются внешним сервисам.
      </p>
    )
  },
  {
    icon: <IconTrash className="w-5 h-5" />,
    title: 'Удаление данных',
    content: (
      <p>
        Для удаления аккаунта обратитесь в поддержку. Все данные будут безвозвратно удалены
        в течение 30 дней. Логи подключений автоматически удаляются через 90 дней.
      </p>
    )
  },
  {
    icon: <IconFileText className="w-5 h-5" />,
    title: 'Ваши права',
    content: (
      <ul className="space-y-2">
        <li>Право на доступ к своим данным.</li>
        <li>Право на удаление данных («право на забвение»).</li>
        <li>Право на экспорт данных.</li>
        <li>Право отозвать согласие на обработку данных (влечёт удаление аккаунта).</li>
      </ul>
    )
  },
  {
    icon: <IconMail className="w-5 h-5" />,
    title: 'Контакты',
    content: (
      <p>
        По вопросам, связанным с обработкой персональных данных, обращайтесь в Telegram: <a href="https://t.me/XNCsup_bot" target="_blank" rel="noopener noreferrer" className="text-primary-500 hover:underline">@XNCsup_bot</a>.
      </p>
    )
  }
];

const PrivacyPage = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div className="min-h-screen bg-white dark:bg-dark-950 transition-colors">
      <div className="max-w-[800px] mx-auto px-6 py-20 sm:py-28">
        <div className="mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-primary-500/10 border border-primary-500/20 rounded-full mb-4">
            <IconShield className="w-4 h-4 text-primary-500" />
            <span className="text-primary-500 text-[13px] font-semibold">Политика конфиденциальности</span>
          </div>
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 dark:text-white mb-4">
            Политика конфиденциальности
          </h1>
          <p className="text-gray-600 dark:text-dark-400 text-sm">
            Последнее обновление: {currentYear}
          </p>
        </div>

        <div className="space-y-10">
          {sections.map((section) => (
            <div key={section.title} className="bg-gray-50 dark:bg-dark-900/50 rounded-xl p-6 sm:p-8 border border-gray-200 dark:border-dark-800">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-primary-500/10 rounded-lg flex items-center justify-center text-primary-500">
                  {section.icon}
                </div>
                <h2 className="text-lg font-semibold text-gray-900 dark:text-white">{section.title}</h2>
              </div>
              <div className="text-gray-600 dark:text-dark-400 text-sm leading-relaxed space-y-2">
                {section.content}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;
